package com.evoapps.evoshift.ui.workplaces

import com.evoapps.evoshift.widgets.IconButtonWithTooltip
import com.evoapps.evoshift.widgets.OnScreen
import com.evoapps.evoshift.domain.util.calculateDurationMinutes
import com.evoapps.evoshift.ui.util.durationText
import com.evoapps.evoshift.ui.util.templateDurationText
import androidx.compose.foundation.layout.widthIn
import androidx.compose.material3.FilledTonalIconButton
import androidx.compose.material3.IconButtonDefaults
import androidx.compose.ui.semantics.contentDescription
import androidx.compose.ui.semantics.semantics
import evoshift.composeapp.generated.resources.skeleton_edit_shift_template
import evoshift.composeapp.generated.resources.skeleton_delete_shift_template
import evoshift.composeapp.generated.resources.skeleton_delete_shift_template_title
import evoshift.composeapp.generated.resources.skeleton_shift_template_used_in
import evoshift.composeapp.generated.resources.skeleton_day_template_usage
import evoshift.composeapp.generated.resources.skeleton_delete_and_remove
import org.jetbrains.compose.resources.pluralStringResource
import evoshift.composeapp.generated.resources.skeleton_shift_count
import com.evoapps.evoshift.widgets.ProvideScreenColors
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import com.evoapps.evoshift.ui.theme.animateItemIfMotion
import com.evoapps.evoshift.widgets.EvoTopBar
import com.evoapps.evoshift.widgets.MessageEffect
import com.evoapps.evoshift.widgets.TopBarAction
import com.evoapps.evoshift.widgets.helpAction
import com.evoapps.evoshift.ui.notifications.notificationsAction
import com.evoapps.evoshift.widgets.helpExplainerAction
import evoshift.composeapp.generated.resources.skeleton_remove_one_shift
import evoshift.composeapp.generated.resources.skeleton_add_one_shift
import evoshift.composeapp.generated.resources.time_same_start_end
import evoshift.composeapp.generated.resources.skeleton_no_roles_defined
import evoshift.composeapp.generated.resources.field_required
import evoshift.composeapp.generated.resources.delete_named_confirm
import com.evoapps.evoshift.widgets.parseClockTime
import com.evoapps.evoshift.widgets.EvoTimeField
import com.evoapps.evoshift.widgets.EvoTextField
import com.evoapps.evoshift.widgets.EvoSecondaryButton
import com.evoapps.evoshift.widgets.EvoPrimaryButton
import com.evoapps.evoshift.widgets.EvoListRow
import com.evoapps.evoshift.widgets.EvoDropdown
import com.evoapps.evoshift.widgets.EvoDialog
import com.evoapps.evoshift.widgets.HelpButton
import evoshift.composeapp.generated.resources.settings_help_roster_blueprint
import com.evoapps.evoshift.widgets.EvoConfirmDialog
import com.evoapps.evoshift.widgets.EvoCheckboxRow
import com.evoapps.evoshift.widgets.EvoBottomSheet
import com.evoapps.evoshift.widgets.ErrorOnNavy
import com.evoapps.evoshift.widgets.DialogWidth
import com.evoapps.evoshift.widgets.DialogSection
import com.evoapps.evoshift.widgets.DialogAction
import com.evoapps.evoshift.ui.LightMetallicBrush
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.material.icons.filled.ViewDay
import androidx.compose.material.icons.filled.Schedule
import androidx.compose.foundation.text.KeyboardActions
import com.evoapps.evoshift.ui.LightGold
import com.evoapps.evoshift.ui.adaptive.WideContentMaxWidth
import com.evoapps.evoshift.ui.adaptive.contentWidth
import evoshift.composeapp.generated.resources.skeleton_day_summary
import evoshift.composeapp.generated.resources.skeleton_skills_count
import com.evoapps.evoshift.ui.util.asString
import evoshift.composeapp.generated.resources.duplicate
import evoshift.composeapp.generated.resources.switch_view
import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.Canvas
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import com.evoapps.evoshift.ui.adaptive.LocalWindowWidthClass
import com.evoapps.evoshift.ui.adaptive.TwoPane
import com.evoapps.evoshift.ui.adaptive.handCursor
import com.evoapps.evoshift.ui.adaptive.hoverLift
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.offset
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.verticalScroll
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ArrowBack
import androidx.compose.material.icons.automirrored.filled.List
import androidx.compose.material.icons.filled.Add
import androidx.compose.material.icons.filled.ArrowDropDown
import androidx.compose.material.icons.filled.ContentCopy
import androidx.compose.material.icons.filled.DateRange
import androidx.compose.material.icons.filled.Delete
import androidx.compose.material.icons.filled.Edit
import androidx.compose.material.icons.filled.EditCalendar
import androidx.compose.material.icons.filled.Info
import androidx.compose.material.icons.filled.Remove
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.DropdownMenu
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Scaffold
import androidx.compose.material3.SnackbarHost
import androidx.compose.material3.SnackbarHostState
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.material3.TopAppBar
import androidx.compose.material3.TopAppBarDefaults
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.geometry.Size
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.evoapps.evoshift.domain.model.DayTemplate
import com.evoapps.evoshift.domain.model.ShiftTemplate
import com.evoapps.evoshift.ui.Cream
import com.evoapps.evoshift.ui.DarkGold
import com.evoapps.evoshift.ui.DeepNavy
import com.evoapps.evoshift.ui.GoldMetallicBrush
import com.evoapps.evoshift.viewmodels.SkeletonEditorEvent
import com.evoapps.evoshift.viewmodels.SkeletonEditorViewModel
import com.evoapps.evoshift.widgets.RegularCard
import evoshift.composeapp.generated.resources.Res
import evoshift.composeapp.generated.resources.close
import evoshift.composeapp.generated.resources.dashboard_weekly_skeleton
import evoshift.composeapp.generated.resources.day_friday
import evoshift.composeapp.generated.resources.day_monday
import evoshift.composeapp.generated.resources.day_saturday
import evoshift.composeapp.generated.resources.day_sunday
import evoshift.composeapp.generated.resources.day_thursday
import evoshift.composeapp.generated.resources.day_tuesday
import evoshift.composeapp.generated.resources.day_wednesday
import evoshift.composeapp.generated.resources.delete
import evoshift.composeapp.generated.resources.edit
import evoshift.composeapp.generated.resources.ok
import evoshift.composeapp.generated.resources.roster_end_time
import evoshift.composeapp.generated.resources.roster_start_time
import evoshift.composeapp.generated.resources.save
import evoshift.composeapp.generated.resources.skeleton_add_existing
import evoshift.composeapp.generated.resources.skeleton_create_day_template
import evoshift.composeapp.generated.resources.skeleton_create_new_definition
import evoshift.composeapp.generated.resources.skeleton_day_off
import evoshift.composeapp.generated.resources.skeleton_day_templates
import evoshift.composeapp.generated.resources.skeleton_delete_template
import evoshift.composeapp.generated.resources.skeleton_delete_template_confirm
import evoshift.composeapp.generated.resources.skeleton_delete_this_template
import evoshift.composeapp.generated.resources.skeleton_editing
import evoshift.composeapp.generated.resources.skeleton_info_desc
import evoshift.composeapp.generated.resources.skeleton_manage_templates
import evoshift.composeapp.generated.resources.skeleton_name_standard_hint
import evoshift.composeapp.generated.resources.skeleton_new
import evoshift.composeapp.generated.resources.skeleton_new_day_template
import evoshift.composeapp.generated.resources.skeleton_new_definition
import evoshift.composeapp.generated.resources.skeleton_new_name
import evoshift.composeapp.generated.resources.skeleton_no_role
import evoshift.composeapp.generated.resources.skeleton_no_role_clear
import evoshift.composeapp.generated.resources.skeleton_no_shifts_empty
import evoshift.composeapp.generated.resources.skeleton_no_shifts_in_template
import evoshift.composeapp.generated.resources.skeleton_off
import evoshift.composeapp.generated.resources.skeleton_rename_template
import evoshift.composeapp.generated.resources.skeleton_required_skills
import evoshift.composeapp.generated.resources.skeleton_role_optional
import evoshift.composeapp.generated.resources.skeleton_select_shift
import evoshift.composeapp.generated.resources.skeleton_shift_definitions
import evoshift.composeapp.generated.resources.skeleton_start_day_template
import evoshift.composeapp.generated.resources.skeleton_start_day_template_desc
import evoshift.composeapp.generated.resources.skeleton_tap_to_add_first_shift
import evoshift.composeapp.generated.resources.skeleton_total_hours
import evoshift.composeapp.generated.resources.skeleton_working_week
import org.jetbrains.compose.resources.stringResource
import kotlin.math.absoluteValue

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun SkeletonEditorScreen(
    viewModel: SkeletonEditorViewModel,
    onNavigateBack: () -> Unit,
    /** SH-219: opened from the start path's shift templates step: the templates' sheet at once. */
    openShiftTemplates: Boolean = false
) {
    val state by viewModel.uiState.collectAsStateWithLifecycle()
    // Once per visit (not again after a rotation or when coming back to this screen).
    var shiftTemplatesOpened by androidx.compose.runtime.saveable.rememberSaveable { mutableStateOf(false) }
    androidx.compose.runtime.LaunchedEffect(openShiftTemplates) {
        if (openShiftTemplates && !shiftTemplatesOpened) {
            shiftTemplatesOpened = true
            viewModel.onEvent(SkeletonEditorEvent.ToggleShiftTemplateManager(true))
        }
    }
    val snackbarHostState = remember { SnackbarHostState() }

    var showCreateDayTemplateDialog by remember { mutableStateOf(false) }
    var showCreateShiftTemplateDialog by remember { mutableStateOf(false) }
    var editingShiftTemplate by remember { mutableStateOf<ShiftTemplate?>(null) }
    var showAddShiftSelector by remember { mutableStateOf(false) }
    var showRenameDialog by remember { mutableStateOf(false) }
    var showDeleteConfirmationDialog by remember { mutableStateOf(false) }

    var isTimelineView by remember { mutableStateOf(true) }

    // SH-188: cleared once shown, so the same failure twice in a row is reported twice.
    MessageEffect(state.error, snackbarHostState, onShown = { viewModel.onEvent(SkeletonEditorEvent.ErrorShown) })

    Scaffold(
        snackbarHost = { SnackbarHost(snackbarHostState) },
        containerColor = Cream,
        topBar = {
            EvoTopBar(
                title = stringResource(Res.string.dashboard_weekly_skeleton),
                onBack = onNavigateBack,
                actions = buildList {
                    add(
                        helpExplainerAction(
                            title = stringResource(Res.string.dashboard_weekly_skeleton),
                            text = stringResource(Res.string.settings_help_roster_blueprint)
                        )
                    )
                    if (state.availableDayTemplates.isNotEmpty()) {
                        add(
                            TopBarAction(
                                stringResource(Res.string.skeleton_manage_templates), Icons.AutoMirrored.Filled.List,
                                { viewModel.onEvent(SkeletonEditorEvent.ToggleShiftTemplateManager(true)) }
                            )
                        )
                    }
                }
            )
        }
    ) { padding ->
        Box(modifier = Modifier.padding(padding).fillMaxSize()) {
            // Only before anything is on screen; saves and re-reads update the editor in place.
            if (state.isLoading && state.availableDayTemplates.isEmpty() && state.availableShiftTemplates.isEmpty()) {
                CircularProgressIndicator(
                    modifier = Modifier.align(Alignment.Center),
                    color = DarkGold
                )
            } else {
                val getTemplateDescription: @Composable (DayTemplate) -> String = { template ->
                    val shifts = template.shiftTemplateIds.mapNotNull { id ->
                        state.availableShiftTemplates.find { it.id == id }
                    }
                    // SH-190: the exact length ("15 h 30 min"), not rounded to whole hours.
                    val totalMinutes = shifts.sumOf { calculateDurationMinutes(it.startTime, it.endTime) }
                    stringResource(Res.string.skeleton_day_summary, template.name, shifts.size, durationText(totalMinutes))
                }

                if (state.availableDayTemplates.isEmpty()) {
                    EmptyState(onCreateRequest = { showCreateDayTemplateDialog = true })
                } else {
                    Column(
                        modifier = Modifier
                            .fillMaxSize()
                            .verticalScroll(rememberScrollState())
                            .contentWidth(WideContentMaxWidth)
                            .padding(16.dp),
                        verticalArrangement = Arrangement.spacedBy(24.dp)
                    ) {
                        // Info Card
                        RegularCard {
                            Row(
                                Modifier.padding(16.dp),
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                Icon(Icons.Default.Info, null, tint = DeepNavy)
                                Spacer(Modifier.width(12.dp))
                                Text(
                                    stringResource(Res.string.skeleton_info_desc),
                                    style = MaterialTheme.typography.bodySmall,
                                    color = DeepNavy
                                )
                            }
                        }

                        // Both sections in both layouts: stacked on phones, side by side on wide
                        // windows (the week on the left, the day templates it uses on the right).
                        val weekSection: @Composable () -> Unit = {
                            // --- SECTION 1: WORKING WEEK ---
                            Text(
                                stringResource(Res.string.skeleton_working_week),
                                style = MaterialTheme.typography.titleMedium,
                                fontWeight = FontWeight.Bold,
                                color = DeepNavy
                            )

                            val dayLabels = listOf(
                                Res.string.day_monday,
                                Res.string.day_tuesday,
                                Res.string.day_wednesday,
                                Res.string.day_thursday,
                                Res.string.day_friday,
                                Res.string.day_saturday,
                                Res.string.day_sunday
                            )

                            val dayOrder = (0..6).map { (it + state.firstDayOfWeek - 1) % 7 + 1 }

                            Column(verticalArrangement = Arrangement.spacedBy(16.dp)) {
                                dayOrder.forEach { isoDay ->
                                    val name = stringResource(dayLabels[isoDay - 1])
                                    val assignedTemplateId = state.weekSkeleton[isoDay]
                                    val assignedTemplate =
                                        state.availableDayTemplates.find { it.id == assignedTemplateId }
                                    val shifts = assignedTemplate?.shiftTemplateIds?.mapNotNull { id ->
                                        state.availableShiftTemplates.find { it.id == id }
                                    } ?: emptyList()

                                    WeekDayPreviewCard(
                                        dayName = name,
                                        selectedTemplate = assignedTemplate,
                                        shifts = shifts,
                                        templateDescriptionProvider = getTemplateDescription,
                                        onChangeTemplate = { newId ->
                                            viewModel.onEvent(
                                                SkeletonEditorEvent.AssignTemplateToDayOfWeek(
                                                    isoDay,
                                                    newId
                                                )
                                            )
                                        },
                                        onEditTemplate = {
                                            if (assignedTemplate != null) {
                                                viewModel.onEvent(
                                                    SkeletonEditorEvent.SelectDayTemplateForEditing(
                                                        assignedTemplate.id
                                                    )
                                                )
                                            }
                                        },
                                        availableTemplates = state.availableDayTemplates
                                    )
                                }
                            }
                        }
                        val templatesSection: @Composable () -> Unit = {
                            // --- SECTION 2: DAY TEMPLATES ---
                            Row(
                                modifier = Modifier.fillMaxWidth(),
                                horizontalArrangement = Arrangement.SpaceBetween,
                                verticalAlignment = Alignment.CenterVertically
                            ) {
                                Text(
                                    stringResource(Res.string.skeleton_day_templates),
                                    style = MaterialTheme.typography.titleMedium,
                                    fontWeight = FontWeight.Bold,
                                    color = DeepNavy
                                )
                                Box(
                                    modifier = Modifier
                                        .clip(RoundedCornerShape(8.dp))
                                        .background(GoldMetallicBrush)
                                        .handCursor().clickable { showCreateDayTemplateDialog = true }
                                        .padding(horizontal = 12.dp, vertical = 6.dp)
                                ) {
                                    Row(verticalAlignment = Alignment.CenterVertically) {
                                        Icon(
                                            Icons.Default.Add,
                                            null,
                                            tint = DeepNavy,
                                            modifier = Modifier.size(18.dp)
                                        )
                                        Spacer(Modifier.width(4.dp))
                                        Text(
                                            stringResource(Res.string.skeleton_new),
                                            color = DeepNavy,
                                            fontWeight = FontWeight.Bold,
                                            fontSize = 14.sp
                                        )
                                    }
                                }
                            }

                            Column(verticalArrangement = Arrangement.spacedBy(12.dp)) {
                                state.availableDayTemplates.forEach { template ->
                                    RegularCard(
                                        modifier = Modifier.hoverLift(),
                                        onClick = {
                                            viewModel.onEvent(
                                                SkeletonEditorEvent.SelectDayTemplateForEditing(
                                                    template.id
                                                )
                                            )
                                        }
                                    ) {
                                        Row(
                                            modifier = Modifier.padding(16.dp).fillMaxWidth(),
                                            horizontalArrangement = Arrangement.SpaceBetween,
                                            verticalAlignment = Alignment.CenterVertically
                                        ) {
                                            Column(modifier = Modifier.weight(1f)) {
                                                Text(
                                                    template.name,
                                                    fontWeight = FontWeight.Bold,
                                                    color = DeepNavy
                                                )
                                                val shiftCount = template.shiftTemplateIds.size
                                                val emptyString =
                                                    stringResource(Res.string.skeleton_no_shifts_empty)
                                                val desc =
                                                    if (shiftCount == 0) emptyString else getTemplateDescription(
                                                        template
                                                    ).substringAfter("(").dropLast(1)
                                                Text(
                                                    desc,
                                                    style = MaterialTheme.typography.bodySmall,
                                                    color = DeepNavy.copy(alpha = 0.6f)
                                                )
                                            }
                                            Row(verticalAlignment = Alignment.CenterVertically) {
                                                IconButtonWithTooltip(onClick = {
                                                    viewModel.onEvent(
                                                        SkeletonEditorEvent.DuplicateDayTemplate(
                                                            template.id
                                                        )
                                                    )
                                                },
                                                tooltip = stringResource(Res.string.duplicate)) {
                                                    Icon(
                                                        Icons.Default.ContentCopy,
                                                        stringResource(Res.string.duplicate),
                                                        tint = DeepNavy.copy(alpha = 0.5f)
                                                    )
                                                }
                                                Icon(
                                                    Icons.Default.Edit,
                                                    null,
                                                    tint = DeepNavy.copy(alpha = 0.8f),
                                                    modifier = Modifier.size(20.dp)
                                                )
                                            }
                                        }
                                    }
                                }
                            }
                        }

                        if (LocalWindowWidthClass.current.isExpanded) {
                            TwoPane(
                                firstWeight = 0.58f,
                                first = {
                                    Column(verticalArrangement = Arrangement.spacedBy(24.dp)) { weekSection() }
                                },
                                second = {
                                    Column(verticalArrangement = Arrangement.spacedBy(24.dp)) { templatesSection() }
                                }
                            )
                        } else {
                            weekSection()

                            HorizontalDivider(color = DeepNavy.copy(alpha = 0.1f))

                            templatesSection()
                        }

                        Spacer(Modifier.height(40.dp))
                    }
                }
            }
        }
    }

    // --- SHEET: EDIT DAY TEMPLATE ---
    if (state.selectedDayTemplateId != null) {
        val template = state.availableDayTemplates.find { it.id == state.selectedDayTemplateId }
        val shiftsInTemplate = state.getShiftsForSelectedTemplate()
        val totalMinutes = shiftsInTemplate.sumOf { calculateDurationMinutes(it.startTime, it.endTime) }

        EvoBottomSheet(
            onDismiss = { viewModel.onEvent(SkeletonEditorEvent.SelectDayTemplateForEditing(null)) },
            title = stringResource(Res.string.skeleton_editing, template?.name ?: ""),
            subtitle = stringResource(Res.string.skeleton_total_hours, durationText(totalMinutes)),
            icon = Icons.Default.ViewDay,
            scrollable = false,
            headerActions = {
                IconButtonWithTooltip(onClick = { isTimelineView = !isTimelineView }, modifier = Modifier.handCursor(), tooltip = stringResource(Res.string.switch_view)) {
                    Icon(
                        imageVector = if (isTimelineView) Icons.AutoMirrored.Filled.List else Icons.Default.DateRange,
                        contentDescription = stringResource(Res.string.switch_view),
                        tint = LightGold
                    )
                }
                IconButtonWithTooltip(onClick = { showRenameDialog = true }, modifier = Modifier.handCursor(), tooltip = stringResource(Res.string.edit)) {
                    Icon(Icons.Default.Edit, stringResource(Res.string.edit), tint = LightGold)
                }
            }
        ) {
            // The shifts sit on a light panel: the timeline and the cards are drawn for cream.
            Box(
                Modifier
                    .weight(1f)
                    .fillMaxWidth()
                    .padding(horizontal = 16.dp)
                    .clip(RoundedCornerShape(20.dp))
                    .background(LightMetallicBrush)
            ) {
                ProvideScreenColors {
                if (shiftsInTemplate.isEmpty()) {
                    Box(
                        Modifier.fillMaxSize()
                            .handCursor().clickable { showCreateShiftTemplateDialog = true },
                        contentAlignment = Alignment.Center
                    ) {
                        Column(horizontalAlignment = Alignment.CenterHorizontally) {
                            Text(
                                stringResource(Res.string.skeleton_no_shifts_in_template),
                                style = MaterialTheme.typography.bodyMedium,
                                color = DeepNavy.copy(alpha = 0.7f)
                            )
                            Spacer(Modifier.height(8.dp))
                            Text(
                                stringResource(Res.string.skeleton_tap_to_add_first_shift),
                                color = OnScreen.accent,
                                fontWeight = FontWeight.Bold
                            )
                        }
                    }
                } else {
                    if (isTimelineView) {
                        DetailedDayTimeline(
                            shifts = shiftsInTemplate,
                            onAddShift = { shiftTemplateId ->
                                viewModel.onEvent(SkeletonEditorEvent.AddShiftToDayTemplate(template!!.id, shiftTemplateId))
                            },
                            onRemoveShift = { index ->
                                viewModel.onEvent(
                                    SkeletonEditorEvent.RemoveShiftFromDayTemplate(
                                        template!!.id,
                                        index
                                    )
                                )
                            }
                        )
                    } else {
                        val groupedShifts = shiftsInTemplate.withIndex().groupBy {
                            Triple(it.value.id, it.value.startTime, it.value.endTime)
                        }.values.toList()

                        LazyColumn(
                            Modifier.fillMaxSize(),
                            contentPadding = PaddingValues(12.dp),
                            verticalArrangement = Arrangement.spacedBy(8.dp)
                        ) {
                            items(groupedShifts, key = { g -> g.first().value.let { "${it.id}-${it.startTime}-${it.endTime}" } }) { group ->
                                Box(Modifier.animateItemIfMotion(this)) {
                                    val firstItem = group.first().value
                                    val count = group.size

                                    RegularCard {
                                        ShiftItemRow(
                                            shiftTemplate = firstItem,
                                            isDark = false,
                                            count = count,
                                            onRemove = {
                                                // Remove one instance (last added index)
                                                val indexToRemove = group.maxOf { it.index }
                                                viewModel.onEvent(
                                                    SkeletonEditorEvent.RemoveShiftFromDayTemplate(
                                                        template!!.id,
                                                        indexToRemove
                                                    )
                                                )
                                            },
                                            onAdd = {
                                                // Add one more instance of this shift template
                                                viewModel.onEvent(
                                                    SkeletonEditorEvent.AddShiftToDayTemplate(
                                                        template!!.id,
                                                        firstItem.id
                                                    )
                                                )
                                            }
                                        )
                                    }
                                }
                            }
                        }
                    }
                }
                }
            }

            // Footer
            Column(
                modifier = Modifier.fillMaxWidth().padding(start = 16.dp, end = 16.dp, top = 16.dp, bottom = 24.dp),
                verticalArrangement = Arrangement.spacedBy(8.dp)
            ) {
                Row(horizontalArrangement = Arrangement.spacedBy(12.dp)) {
                    EvoPrimaryButton(
                        DialogAction(stringResource(Res.string.skeleton_add_existing), { showAddShiftSelector = true }, icon = Icons.Default.Add),
                        Modifier.weight(1f)
                    )
                    EvoSecondaryButton(
                        DialogAction(stringResource(Res.string.skeleton_new_definition), { showCreateShiftTemplateDialog = true }),
                        Modifier.weight(1f)
                    )
                }
                TextButton(
                    onClick = { showDeleteConfirmationDialog = true },
                    colors = ButtonDefaults.textButtonColors(contentColor = ErrorOnNavy),
                    modifier = Modifier.fillMaxWidth().handCursor()
                ) {
                    Icon(Icons.Default.Delete, null)
                    Spacer(Modifier.width(8.dp))
                    Text(stringResource(Res.string.skeleton_delete_this_template))
                }
            }
        }
    }

    // --- SHEET: SHIFT TEMPLATES MANAGER ---
    var shiftTemplateToDelete by remember { mutableStateOf<ShiftTemplate?>(null) }
    if (state.isManagingShiftTemplates) {
        EvoBottomSheet(
            onDismiss = { viewModel.onEvent(SkeletonEditorEvent.ToggleShiftTemplateManager(false)) },
            title = stringResource(Res.string.skeleton_shift_definitions),
            icon = Icons.Default.Schedule
        ) {
            EvoPrimaryButton(
                DialogAction(stringResource(Res.string.skeleton_create_new_definition), { showCreateShiftTemplateDialog = true }, icon = Icons.Default.Add),
                Modifier.fillMaxWidth()
            )
            // SH-219: the usual shifts to start from, one tap each (then edited like any other).
            ShiftTemplatePresetsSection(state.availableShiftTemplates) { name, start, end ->
                viewModel.onEvent(SkeletonEditorEvent.CreateShiftTemplate(name, start, end, "", emptyList()))
            }
            state.notice?.let { ShiftTemplateNote(it.asString()) }
            state.availableShiftTemplates.forEach { template ->
                ShiftTemplateRow(
                    template = template,
                    onClick = { editingShiftTemplate = template },
                    onEdit = { editingShiftTemplate = template },
                    onDelete = { shiftTemplateToDelete = template }
                )
            }
        }
    }

    // --- PICKER: ADD AN EXISTING SHIFT TEMPLATE TO THE DAY TEMPLATE ---
    // SH-190: each row also edits or deletes the shift template (the same editor and confirmation
    // as the list above); the day template's sheet stays open underneath with its changes.
    if (showAddShiftSelector && state.selectedDayTemplateId != null) {
        SelectShiftTemplateDialog(
            templates = state.availableShiftTemplates,
            note = state.notice?.asString(),
            onDismiss = {
                showAddShiftSelector = false
                viewModel.onEvent(SkeletonEditorEvent.NoticeShown)
            },
            onSelect = {
                viewModel.onEvent(
                    SkeletonEditorEvent.AddShiftToDayTemplate(
                        state.selectedDayTemplateId!!,
                        it
                    )
                )
                showAddShiftSelector = false
                viewModel.onEvent(SkeletonEditorEvent.NoticeShown)
            },
            onEdit = { editingShiftTemplate = it },
            onDelete = { shiftTemplateToDelete = it }
        )
    }

    shiftTemplateToDelete?.let { template ->
        ShiftTemplateDeleteDialog(
            template = template,
            usedIn = state.dayTemplatesUsing(template.id),
            onConfirm = {
                viewModel.onEvent(SkeletonEditorEvent.DeleteShiftTemplate(template.id))
                shiftTemplateToDelete = null
            },
            onDismiss = { shiftTemplateToDelete = null }
        )
    }

    // --- DIALOGS ---
    if (showCreateDayTemplateDialog) {
        SimpleTextInputDialog(
            title = stringResource(Res.string.skeleton_new_day_template),
            label = stringResource(Res.string.skeleton_name_standard_hint),
            onDismiss = { showCreateDayTemplateDialog = false },
            onConfirm = {
                viewModel.onEvent(SkeletonEditorEvent.CreateDayTemplate(it))
                showCreateDayTemplateDialog = false
            }
        )
    }

    if (showRenameDialog && state.selectedDayTemplateId != null) {
        val currentName =
            state.availableDayTemplates.find { it.id == state.selectedDayTemplateId }?.name ?: ""
        SimpleTextInputDialog(
            title = stringResource(Res.string.skeleton_rename_template),
            label = stringResource(Res.string.skeleton_new_name),
            initialValue = currentName,
            onDismiss = { showRenameDialog = false },
            onConfirm = {
                viewModel.onEvent(
                    SkeletonEditorEvent.RenameDayTemplate(
                        state.selectedDayTemplateId!!,
                        it
                    )
                )
                showRenameDialog = false
            }
        )
    }

    if (showDeleteConfirmationDialog && state.selectedDayTemplateId != null) {
        EvoConfirmDialog(
            title = stringResource(Res.string.skeleton_delete_template),
            text = stringResource(Res.string.skeleton_delete_template_confirm),
            confirmLabel = stringResource(Res.string.delete),
            onConfirm = {
                viewModel.onEvent(SkeletonEditorEvent.DeleteDayTemplate(state.selectedDayTemplateId!!))
                showDeleteConfirmationDialog = false
            },
            onDismiss = { showDeleteConfirmationDialog = false },
            destructive = true,
            icon = Icons.Default.Delete
        )
    }

    if (showCreateShiftTemplateDialog || editingShiftTemplate != null) {
        val isEditing = editingShiftTemplate != null
        CreateShiftTemplateDialog(
            initialName = editingShiftTemplate?.name ?: "",
            initialStart = editingShiftTemplate?.startTime ?: "08:00",
            initialEnd = editingShiftTemplate?.endTime ?: "16:00",
            initialRole = editingShiftTemplate?.role ?: "",
            initialSkills = editingShiftTemplate?.skills ?: emptyList(),
            availableRoles = state.availableRoles,
            availableSkills = state.availableSkills,
            onDismiss = { showCreateShiftTemplateDialog = false; editingShiftTemplate = null },
            onConfirm = { name, start, end, role, skills ->
                if (isEditing) {
                    val updated = editingShiftTemplate!!.copy(
                        name = name,
                        startTime = start,
                        endTime = end,
                        role = role,
                        skills = skills
                    )
                    viewModel.onEvent(SkeletonEditorEvent.UpdateShiftTemplate(updated))
                } else {
                    viewModel.onEvent(
                        SkeletonEditorEvent.CreateShiftTemplate(
                            name,
                            start,
                            end,
                            role,
                            skills
                        )
                    )
                }
                showCreateShiftTemplateDialog = false
                editingShiftTemplate = null
            }
        )
    }
}

@Composable
fun EmptyState(onCreateRequest: () -> Unit) {
    Column(
        modifier = Modifier.fillMaxSize().padding(32.dp),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.Center
    ) {
        Icon(
            imageVector = Icons.Default.EditCalendar,
            contentDescription = null,
            modifier = Modifier.size(80.dp),
            tint = DarkGold
        )
        Spacer(Modifier.height(24.dp))
        Text(
            text = stringResource(Res.string.skeleton_start_day_template),
            style = MaterialTheme.typography.headlineSmall,
            textAlign = TextAlign.Center,
            color = DeepNavy,
            fontWeight = FontWeight.Bold
        )
        Spacer(Modifier.height(12.dp))
        Text(
            text = stringResource(Res.string.skeleton_start_day_template_desc),
            style = MaterialTheme.typography.bodyMedium,
            textAlign = TextAlign.Center,
            color = DeepNavy.copy(alpha = 0.6f)
        )
        Spacer(Modifier.height(32.dp))
        Box(
            modifier = Modifier
                .fillMaxWidth()
                .height(50.dp)
                .clip(RoundedCornerShape(12.dp))
                .background(GoldMetallicBrush)
                .handCursor().clickable { onCreateRequest() },
            contentAlignment = Alignment.Center
        ) {
            Row(verticalAlignment = Alignment.CenterVertically) {
                Icon(Icons.Default.Add, null, tint = DeepNavy)
                Spacer(Modifier.width(8.dp))
                Text(
                    stringResource(Res.string.skeleton_create_day_template),
                    color = DeepNavy,
                    fontWeight = FontWeight.Bold
                )
            }
        }
    }
}

/**
 * One kind of shift in the day template's list view: its name, times, exact length and role, and
 * the − count + stepper. SH-190: on a narrow card (a 360 dp phone) the stepper goes under the name.
 */
@Composable
fun ShiftItemRow(
    shiftTemplate: ShiftTemplate,
    isDark: Boolean = false,
    count: Int = 1,
    onRemove: () -> Unit,
    onAdd: () -> Unit
) {
    val textColor = if (isDark) Color.White else DeepNavy
    val info: @Composable (Modifier) -> Unit = { modifier ->
        Column(modifier) {
            Text(shiftTemplate.name, fontWeight = FontWeight.Bold, color = textColor)
            val skillsText =
                if (shiftTemplate.skills.isNotEmpty()) " + " + stringResource(Res.string.skeleton_skills_count, shiftTemplate.skills.size) else ""

            val roleName = shiftTemplate.role ?: stringResource(Res.string.skeleton_no_role)
            val length = templateDurationText(shiftTemplate.startTime, shiftTemplate.endTime)
            Text(
                "${shiftTemplate.startTime} - ${shiftTemplate.endTime} • $length • ${roleName}$skillsText",
                style = MaterialTheme.typography.bodyMedium,
                color = textColor.copy(alpha = 0.6f)
            )
        }
    }
    BoxWithConstraints(Modifier.fillMaxWidth()) {
        if (maxWidth < StepperBesideNameMinWidth) {
            Column(
                modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp, vertical = 12.dp),
                verticalArrangement = Arrangement.spacedBy(8.dp)
            ) {
                info(Modifier.fillMaxWidth())
                ShiftCountStepper(
                    name = shiftTemplate.name,
                    count = count,
                    onRemove = onRemove,
                    onAdd = onAdd,
                    isDark = isDark,
                    modifier = Modifier.align(Alignment.End)
                )
            }
        } else {
            Row(
                modifier = Modifier.fillMaxWidth().padding(horizontal = 16.dp, vertical = 12.dp),
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.spacedBy(12.dp)
            ) {
                info(Modifier.weight(1f))
                ShiftCountStepper(shiftTemplate.name, count, onRemove, onAdd, isDark = isDark)
            }
        }
    }
}

/** Narrower cards put the stepper under the shift's name. */
private val StepperBesideNameMinWidth = 340.dp

/**
 * SH-190: how many shifts of one kind the day template has: − [count] +, as 40 dp tonal buttons
 * with 48 dp touch targets, apart enough not to be mis-tapped, named for screen readers ("Remove
 * one shift: Morning"). [showCount] = false where the count is shown elsewhere (the timeline badge).
 */
@Composable
fun ShiftCountStepper(
    name: String,
    count: Int,
    onRemove: () -> Unit,
    onAdd: () -> Unit,
    modifier: Modifier = Modifier,
    isDark: Boolean = false,
    showCount: Boolean = true
) {
    val ink = if (isDark) Color.White else DeepNavy
    Row(
        modifier = modifier,
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(if (showCount) 4.dp else 12.dp)
    ) {
        FilledTonalIconButton(
            onClick = onRemove,
            modifier = Modifier.size(40.dp).handCursor(),
            colors = IconButtonDefaults.filledTonalIconButtonColors(
                containerColor = Color.Red.copy(alpha = 0.10f),
                contentColor = Color(0xFFB3261E)
            )
        ) {
            Icon(Icons.Default.Remove, stringResource(Res.string.skeleton_remove_one_shift, name), modifier = Modifier.size(22.dp))
        }
        if (showCount) {
            val countDescription = stringResource(Res.string.skeleton_shift_count, count)
            Text(
                text = "$count",
                style = MaterialTheme.typography.titleMedium,
                fontWeight = FontWeight.Bold,
                color = ink,
                textAlign = TextAlign.Center,
                modifier = Modifier.widthIn(min = 32.dp).semantics { contentDescription = countDescription }
            )
        }
        FilledTonalIconButton(
            onClick = onAdd,
            modifier = Modifier.size(40.dp).handCursor(),
            colors = IconButtonDefaults.filledTonalIconButtonColors(
                containerColor = ink.copy(alpha = 0.10f),
                contentColor = ink
            )
        ) {
            Icon(Icons.Default.Add, stringResource(Res.string.skeleton_add_one_shift, name), modifier = Modifier.size(22.dp))
        }
    }
}

@Composable
fun WeekDayPreviewCard(
    dayName: String,
    selectedTemplate: DayTemplate?,
    shifts: List<ShiftTemplate>,
    templateDescriptionProvider: @Composable (DayTemplate) -> String,
    onChangeTemplate: (String?) -> Unit,
    onEditTemplate: () -> Unit,
    availableTemplates: List<DayTemplate>
) {
    var expanded by remember { mutableStateOf(false) }

    RegularCard {
        Column(Modifier.padding(16.dp)) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically
            ) {
                Text(
                    dayName,
                    style = MaterialTheme.typography.titleSmall,
                    fontWeight = FontWeight.Bold,
                    color = DeepNavy
                )
                Box {
                    Box(
                        modifier = Modifier
                            .height(32.dp)
                            .clip(RoundedCornerShape(8.dp))
                            .background(Color.White.copy(alpha = 0.5f))
                            .border(1.dp, DeepNavy.copy(alpha = 0.1f), RoundedCornerShape(8.dp))
                            .handCursor().clickable { expanded = true }
                            .padding(horizontal = 12.dp),
                        contentAlignment = Alignment.Center
                    ) {
                        Row(verticalAlignment = Alignment.CenterVertically) {
                            val defaultOff = stringResource(Res.string.skeleton_day_off)
                            val buttonText = selectedTemplate?.let {
                                templateDescriptionProvider(it).substringBefore(" (")
                            } ?: defaultOff
                            Text(
                                buttonText,
                                fontSize = 12.sp,
                                color = DeepNavy,
                                fontWeight = FontWeight.Medium
                            )
                            Spacer(Modifier.width(4.dp))
                            Icon(
                                Icons.Default.ArrowDropDown,
                                null,
                                modifier = Modifier.size(16.dp),
                                tint = DeepNavy
                            )
                        }
                    }
                    DropdownMenu(expanded = expanded, onDismissRequest = { expanded = false }) {
                        DropdownMenuItem(
                            text = {
                                Text(
                                    stringResource(Res.string.skeleton_day_off),
                                    color = Color.Red
                                )
                            },
                            onClick = { onChangeTemplate(null); expanded = false })
                        availableTemplates.forEach { t ->
                            DropdownMenuItem(
                                text = { Text(templateDescriptionProvider(t)) },
                                onClick = { onChangeTemplate(t.id); expanded = false })
                        }
                    }
                }
            }
            Spacer(Modifier.height(12.dp))
            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .height(34.dp)
                    .clip(RoundedCornerShape(8.dp))
                    .background(Color.White.copy(alpha = 0.3f))
                    .border(1.dp, DeepNavy.copy(alpha = 0.05f), RoundedCornerShape(8.dp))
                    .handCursor().clickable { if (selectedTemplate != null) onEditTemplate() }
            ) {
                if (selectedTemplate != null) {
                    MiniDayTimeline(shifts = shifts, modifier = Modifier.fillMaxSize())
                } else {
                    Box(Modifier.fillMaxSize(), contentAlignment = Alignment.Center) {
                        Text(
                            stringResource(Res.string.skeleton_off),
                            style = MaterialTheme.typography.labelSmall,
                            color = DeepNavy.copy(alpha = 0.3f)
                        )
                    }
                }
            }
        }
    }
}

@Composable
fun MiniDayTimeline(shifts: List<ShiftTemplate>, modifier: Modifier = Modifier) {
    Canvas(modifier = modifier) {
        val widthPerHr = size.width / 24f
        val barHeight = size.height
        shifts.forEach { shift ->
            val start = timeStringToFloat(shift.startTime)
            val end = timeStringToFloat(shift.endTime)
            val color = generatePastelColor(shift.name)
            if (end < start) {
                drawRect(
                    color = color.copy(alpha = 0.7f),
                    topLeft = Offset(start * widthPerHr, 0f),
                    size = Size((24 - start) * widthPerHr, barHeight)
                )
                drawRect(
                    color = color.copy(alpha = 0.7f),
                    topLeft = Offset(0f, 0f),
                    size = Size(end * widthPerHr, barHeight)
                )
            } else {
                drawRect(
                    color = color.copy(alpha = 0.7f),
                    topLeft = Offset(start * widthPerHr, 0f),
                    size = Size((end - start) * widthPerHr, barHeight)
                )
            }
        }
    }
}

data class PositionedShift(
    val template: ShiftTemplate,
    val count: Int,
    val start: Float,
    val end: Float,
    val colIndex: Int,
    val totalCols: Int
)

@Composable
fun DetailedDayTimeline(
    shifts: List<ShiftTemplate>,
    onRemoveShift: (Int) -> Unit,
    onAddShift: (String) -> Unit = {}
) {
    val hourHeightPx = 24
    val totalHeight = hourHeightPx * 24
    BoxWithConstraints(
        modifier = Modifier.fillMaxWidth().height(totalHeight.dp)
            .verticalScroll(rememberScrollState())
    ) {
        val totalWidth = maxWidth
        val groupedShifts = shifts.groupBy { it.id }.values.toList()
        val distinctVisuals =
            groupedShifts.map { group -> Triple(group.first(), group.size, group) }
                .sortedBy { timeStringToFloat(it.first.startTime) }
        val positioned = mutableListOf<PositionedShift>()
        val lanes = mutableListOf<Float>()
        distinctVisuals.forEach { (template, count, _) ->
            val start = timeStringToFloat(template.startTime)
            val end = timeStringToFloat(template.endTime)
            val effectiveEnd = if (end < start) 24f + end else end
            var placed = false
            for (i in lanes.indices) {
                if (lanes[i] <= start) {
                    lanes[i] = effectiveEnd
                    positioned.add(PositionedShift(template, count, start, end, i, 1))
                    placed = true
                    break
                }
            }
            if (!placed) {
                lanes.add(effectiveEnd)
                positioned.add(PositionedShift(template, count, start, end, lanes.lastIndex, 1))
            }
        }
        val finalPositioned = positioned.map { p ->
            val overlapGroup = positioned.filter {
                val s1 = it.start
                val e1 = if (it.end < it.start) 24f + it.end else it.end
                val s2 = p.start
                val e2 = if (p.end < p.start) 24f + p.end else p.end
                maxOf(s1, s2) < minOf(e1, e2)
            }
            val maxCol = overlapGroup.maxOfOrNull { it.colIndex } ?: 0
            p.copy(totalCols = maxCol + 1)
        }
        Column {
            for (i in 0..24) {
                Box(modifier = Modifier.height(hourHeightPx.dp).fillMaxWidth()) {
                    HorizontalDivider(color = DeepNavy.copy(alpha = 0.1f))
                    Text(
                        text = "$i:00",
                        style = MaterialTheme.typography.labelSmall,
                        color = OnScreen.onSurfaceVariant,
                        modifier = Modifier.padding(start = 4.dp)
                    )
                }
            }
        }
        finalPositioned.forEach { item ->
            val start = item.start
            val end = item.end
            val duration = if (end < start) (24 - start) + end else end - start
            val topOffset = (start * hourHeightPx).dp
            val height = (duration * hourHeightPx).dp
            val availableWidth = totalWidth - 40.dp
            val cardWidth = availableWidth / item.totalCols
            val leftOffset = 40.dp + (cardWidth * item.colIndex)
            generatePastelColor(item.template.name)
            Card(
                colors = CardDefaults.cardColors(containerColor = Color(0xFFFBF4E9)),
                border = BorderStroke(1.dp, DeepNavy),
                modifier = Modifier.offset(x = leftOffset, y = topOffset).width(cardWidth)
                    .height(height).padding(end = 4.dp, bottom = 2.dp)
            ) {
                // Match visual style from RosterSkeletonScreen's TimelineShiftCard
                Box(modifier = Modifier.fillMaxSize().padding(4.dp)) {
                    Column(modifier = Modifier.align(Alignment.TopStart)) {
                        Text(
                            text = item.template.role
                                ?: stringResource(Res.string.skeleton_no_role),
                            style = MaterialTheme.typography.titleSmall,
                            fontWeight = FontWeight.Bold,
                            color = DeepNavy,
                            fontSize = 11.sp
                        )
                        Text(
                            text = ". ${item.template.startTime} - ${item.template.endTime}",
                            style = MaterialTheme.typography.labelSmall,
                            color = DeepNavy.copy(alpha = 0.8f),
                            fontSize = 10.sp
                        )
                        Text(
                            text = ". " + templateDurationText(item.template.startTime, item.template.endTime),
                            style = MaterialTheme.typography.labelSmall,
                            color = DeepNavy.copy(alpha = 0.8f),
                            fontSize = 10.sp
                        )
                    }

                    // The same -1 / +1 as the list view (one shift of this kind fewer or more).
                    // SH-190: full-size buttons where the block is tall enough, small ones on short shifts.
                    val removeOne = {
                        // Remove ONE of the shifts this block stands for (the last added).
                        val idx = shifts.indexOfLast { it.id == item.template.id }
                        if (idx != -1) onRemoveShift(idx)
                    }
                    if (height >= TimelineFullStepperMinHeight && cardWidth >= TimelineFullStepperMinWidth) {
                        ShiftCountStepper(
                            name = item.template.name,
                            count = item.count,
                            onRemove = removeOne,
                            onAdd = { onAddShift(item.template.id) },
                            showCount = false,
                            modifier = Modifier.align(Alignment.BottomEnd)
                        )
                    } else Row(
                        modifier = Modifier.align(Alignment.BottomEnd),
                        horizontalArrangement = Arrangement.spacedBy(2.dp)
                    ) {
                        IconButtonWithTooltip(
                            onClick = removeOne,
                            modifier = Modifier.size(24.dp).handCursor(),
                            tooltip = stringResource(Res.string.skeleton_remove_one_shift, item.template.name)
                        ) {
                            Icon(
                                Icons.Default.Remove,
                                stringResource(Res.string.skeleton_remove_one_shift, item.template.name),
                                modifier = Modifier.size(16.dp),
                                tint = Color.Red.copy(alpha = 0.7f)
                            )
                        }
                        IconButtonWithTooltip(
                            onClick = { onAddShift(item.template.id) },
                            modifier = Modifier.size(24.dp).handCursor(),
                            tooltip = stringResource(Res.string.skeleton_add_one_shift, item.template.name)
                        ) {
                            Icon(
                                Icons.Default.Add,
                                stringResource(Res.string.skeleton_add_one_shift, item.template.name),
                                modifier = Modifier.size(16.dp),
                                tint = DeepNavy
                            )
                        }
                    }

                    if (item.count > 0) {
                        Box(
                            modifier = Modifier
                                .align(Alignment.Center)
                                .size(32.dp)
                                .clip(CircleShape)
                                .background(DeepNavy)
                                .border(1.dp, DarkGold, CircleShape),
                            contentAlignment = Alignment.Center
                        ) {
                            Text(
                                text = "x${item.count}",
                                color = Color.White,
                                fontWeight = FontWeight.Bold,
                                fontSize = 12.sp
                            )
                        }
                    }
                }
            }
        }
    }
}

/** Timeline blocks at least this tall (5 hours) and wide get the full-size − / + buttons. */
private val TimelineFullStepperMinHeight = 120.dp
private val TimelineFullStepperMinWidth = 140.dp

fun timeStringToFloat(time: String): Float {
    val parts = time.split(":"); if (parts.size != 2) return 0f
    val h = parts[0].toIntOrNull() ?: 0
    val m = parts[1].toIntOrNull() ?: 0; return h + m / 60f
}

fun generatePastelColor(key: String): Color {
    val hash = key.hashCode()
    val hue = (hash.absoluteValue % 360).toFloat(); return Color.hsl(hue, 0.5f, 0.85f)
}

@Composable
fun CreateShiftTemplateDialog(
    initialName: String = "",
    initialStart: String = "08:00",
    initialEnd: String = "16:00",
    initialRole: String = "",
    initialSkills: List<String> = emptyList(),
    availableRoles: List<String>,
    availableSkills: List<String>,
    onDismiss: () -> Unit,
    onConfirm: (String, String, String, String, List<String>) -> Unit
) {
    var name by remember { mutableStateOf(initialName) }
    var start by remember { mutableStateOf(initialStart) }
    var end by remember { mutableStateOf(initialEnd) }
    var role by remember { mutableStateOf(initialRole.ifBlank { "" }) }
    var selectedSkills by remember { mutableStateOf(initialSkills.toSet()) }
    var tried by remember { mutableStateOf(false) }

    val startTime = parseClockTime(start)
    val endTime = parseClockTime(end)
    val sameTimes = startTime != null && startTime == endTime

    EvoDialog(
        title = if (initialName.isBlank()) stringResource(Res.string.skeleton_new_definition) else stringResource(Res.string.edit),
        subtitle = initialName.takeIf { it.isNotBlank() },
        icon = Icons.Default.Schedule,
        onDismiss = onDismiss,
        bodyArrangement = Arrangement.spacedBy(20.dp),
        confirm = DialogAction(
            stringResource(Res.string.save),
            {
                tried = true
                if (name.isNotBlank() && startTime != null && endTime != null && !sameTimes) {
                    onConfirm(name.trim(), startTime, endTime, role, selectedSkills.toList())
                }
            }
        )
    ) {
        EvoTextField(
            value = name,
            onValueChange = { name = it },
            label = stringResource(Res.string.skeleton_new_name),
            error = stringResource(Res.string.field_required).takeIf { tried && name.isBlank() }
        )
        Row(horizontalArrangement = Arrangement.spacedBy(12.dp)) {
            EvoTimeField(
                value = start,
                onValueChange = { start = it },
                label = stringResource(Res.string.roster_start_time),
                showErrors = tried,
                modifier = Modifier.weight(1f)
            )
            EvoTimeField(
                value = end,
                onValueChange = { end = it },
                label = stringResource(Res.string.roster_end_time),
                placeholder = "16:00",
                showErrors = tried,
                error = stringResource(Res.string.time_same_start_end).takeIf { sameTimes },
                imeAction = ImeAction.Done,
                modifier = Modifier.weight(1f)
            )
        }
        if (availableRoles.isEmpty()) {
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .clip(RoundedCornerShape(12.dp))
                    .background(Color.White.copy(alpha = 0.06f))
                    .padding(12.dp),
                verticalAlignment = Alignment.CenterVertically
            ) {
                Icon(Icons.Default.Info, contentDescription = null, tint = LightGold, modifier = Modifier.size(18.dp))
                Spacer(Modifier.width(10.dp))
                Text(
                    stringResource(Res.string.skeleton_no_roles_defined),
                    style = MaterialTheme.typography.bodySmall,
                    color = Color.White.copy(alpha = 0.75f)
                )
            }
        } else {
            val noRole = stringResource(Res.string.skeleton_no_role_clear)
            EvoDropdown(
                label = stringResource(Res.string.skeleton_role_optional),
                // "" stands for no role; a role removed from the workplace stays selectable.
                options = (listOf("") + availableRoles + role).distinct(),
                selected = role,
                onSelected = { role = it },
                optionLabel = { it.ifBlank { noRole } }
            )
        }
        if (availableSkills.isNotEmpty()) {
            DialogSection(stringResource(Res.string.skeleton_required_skills)) {
                Column {
                    availableSkills.forEach { skill ->
                        EvoCheckboxRow(
                            checked = skill in selectedSkills,
                            onCheckedChange = { checked ->
                                selectedSkills = if (checked) selectedSkills + skill else selectedSkills - skill
                            },
                            label = skill
                        )
                    }
                }
            }
        }
    }
}

@Composable
fun SimpleTextInputDialog(
    title: String,
    label: String,
    initialValue: String = "",
    onDismiss: () -> Unit,
    onConfirm: (String) -> Unit
) {
    var text by remember { mutableStateOf(initialValue) }
    val submit = { if (text.isNotBlank()) onConfirm(text.trim()) }
    EvoDialog(
        title = title,
        icon = Icons.Default.Edit,
        onDismiss = onDismiss,
        width = DialogWidth.Compact,
        confirm = DialogAction(stringResource(Res.string.ok), submit, enabled = text.isNotBlank())
    ) {
        EvoTextField(
            value = text,
            onValueChange = { text = it },
            label = label,
            imeAction = ImeAction.Done,
            keyboardActions = KeyboardActions(onDone = { submit() })
        )
    }
}

/**
 * The day template's "Add Existing" picker: a tap adds the shift template; SH-190: the pencil and
 * the bin edit or delete it right here ([onEdit] / [onDelete] open the shift templates list's
 * editor and confirmation). [note] says what just happened, e.g. that one was deleted.
 */
@Composable
fun SelectShiftTemplateDialog(
    templates: List<ShiftTemplate>,
    onDismiss: () -> Unit,
    onSelect: (String) -> Unit,
    note: String? = null,
    onEdit: ((ShiftTemplate) -> Unit)? = null,
    onDelete: ((ShiftTemplate) -> Unit)? = null
) {
    EvoDialog(
        title = stringResource(Res.string.skeleton_select_shift),
        icon = Icons.Default.Schedule,
        onDismiss = onDismiss,
        dismiss = DialogAction(stringResource(Res.string.close), onDismiss),
        bodyArrangement = Arrangement.spacedBy(8.dp)
    ) {
        note?.let { ShiftTemplateNote(it) }
        templates.forEach { template ->
            ShiftTemplateRow(
                template = template,
                onClick = { onSelect(template.id) },
                onEdit = onEdit?.let { edit -> { edit(template) } },
                onDelete = onDelete?.let { delete -> { delete(template) } }
            )
        }
    }
}

/** "07:00 – 15:30 · 8 h 30 min · Barista": the times, the exact length (SH-190) and the role. */
@Composable
fun shiftTemplateSummary(template: ShiftTemplate): String =
    listOfNotNull(
        "${template.startTime} – ${template.endTime}",
        templateDurationText(template.startTime, template.endTime),
        template.role?.takeIf { it.isNotBlank() }
    ).joinToString(" · ")

/**
 * One shift template in the shift templates list and in the day template's picker: a tap does
 * [onClick]; the pencil and the bin (named for screen readers) edit and delete it.
 */
@Composable
fun ShiftTemplateRow(
    template: ShiftTemplate,
    onClick: () -> Unit,
    onEdit: (() -> Unit)?,
    onDelete: (() -> Unit)?
) {
    EvoListRow(
        headline = template.name,
        supporting = shiftTemplateSummary(template),
        onClick = onClick,
        trailing = if (onEdit == null && onDelete == null) null else {
            {
                Row {
                    if (onEdit != null) {
                        IconButtonWithTooltip(onClick = onEdit, modifier = Modifier.handCursor(), tooltip = stringResource(Res.string.skeleton_edit_shift_template, template.name)) {
                            Icon(
                                Icons.Default.Edit,
                                stringResource(Res.string.skeleton_edit_shift_template, template.name),
                                tint = Color.White.copy(alpha = 0.8f)
                            )
                        }
                    }
                    if (onDelete != null) {
                        IconButtonWithTooltip(onClick = onDelete, modifier = Modifier.handCursor(), tooltip = stringResource(Res.string.skeleton_delete_shift_template, template.name)) {
                            Icon(
                                Icons.Default.Delete,
                                stringResource(Res.string.skeleton_delete_shift_template, template.name),
                                tint = ErrorOnNavy
                            )
                        }
                    }
                }
            }
        }
    )
}

/** A short note above the shift templates (e.g. one was just deleted). */
@Composable
private fun ShiftTemplateNote(text: String) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(12.dp))
            .background(Color.White.copy(alpha = 0.08f))
            .padding(12.dp),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Icon(Icons.Default.Info, contentDescription = null, tint = LightGold, modifier = Modifier.size(18.dp))
        Spacer(Modifier.width(10.dp))
        Text(text, style = MaterialTheme.typography.bodySmall, color = Color.White.copy(alpha = 0.85f))
    }
}

/**
 * Deleting a shift template, from the list or the picker (the same confirmation). SH-190: one that
 * day templates use can be deleted too: the dialog names each of them with how many times it is
 * there ([usedIn]), and confirming removes it from them as well. Rosters keep their shifts.
 */
@Composable
fun ShiftTemplateDeleteDialog(
    template: ShiftTemplate,
    usedIn: List<Pair<String, Int>>,
    onConfirm: () -> Unit,
    onDismiss: () -> Unit
) {
    if (usedIn.isNotEmpty()) {
        val usage = usedIn.map { (day, times) -> pluralStringResource(Res.plurals.skeleton_day_template_usage, times, day, times) }
        EvoConfirmDialog(
            title = stringResource(Res.string.skeleton_delete_shift_template_title, template.name),
            text = stringResource(Res.string.skeleton_shift_template_used_in, usage.joinToString(", ")),
            confirmLabel = stringResource(Res.string.skeleton_delete_and_remove),
            onConfirm = onConfirm,
            onDismiss = onDismiss,
            destructive = true,
            icon = Icons.Default.Delete
        )
    } else {
        EvoConfirmDialog(
            title = stringResource(Res.string.delete),
            text = stringResource(Res.string.delete_named_confirm, template.name),
            confirmLabel = stringResource(Res.string.delete),
            onConfirm = onConfirm,
            onDismiss = onDismiss,
            destructive = true,
            icon = Icons.Default.Delete
        )
    }
}
